import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { WebpageControl } from "WorkItemTracking/Scripts/Controls/WorkItemForm/WebpageControl";
import { WorkItemControl } from "WorkItemTracking/Scripts/Controls/WorkItemForm/WorkItemControl";

import * as WITOM from "WorkItemTracking/Scripts/TFS.WorkItemTracking";

export interface IWebpageControlProps {
    workItem: WITOM.WorkItem;
    options: any;
}

/// <reference types="jquery" />

// This is a proxy component to load the webpage control using LegacyComponent
class WebpageControlProxy extends React.Component<IWebpageControlProps> {
    private _container: HTMLDivElement;
    private _control: WorkItemControl;

    public render(): React.ReactNode {
        if (this._control !== undefined) {
            this._control.bind(this.props.workItem);
        }
        return <div ref={this._resolveContainerRef}></div>;
    }

    public componentDidMount(): void {
        this._renderControl();
    }

    public componentWillUnmount(): void {
        this._disposeFieldControl();
    }

    private _renderControl(): void {
        this._disposeFieldControl();

        const $controlContainer = $(this._container);

        const WebpageControlControl: WebpageControl = new WebpageControl($controlContainer, this.props.options, this.props.workItem.workItemType);
        this._control = WebpageControlControl;
        // Let the control know it's being used within react
        this._control.bind(this.props.workItem);
    }

    private _disposeFieldControl(): void {
        if (this._control) {
            this._control.unbind();
            this._control.dispose();
            this._control = null;
        }
    }

    private _resolveContainerRef = (element: HTMLDivElement): void => {
        this._container = element;
    };
}

registerLWPComponent("webpage-control-proxy", WebpageControlProxy);
